import React from 'react'
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Thankyou() {
  const navigate = useNavigate();

  useEffect(() => {
      const timer = setTimeout(() => {
      navigate("/"); 
      }, 3000);

      return () => clearTimeout(timer); 
  }, [navigate]);

  return (
    <>
      <section className='thankyou-area'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-8 text-center'>
              <img src='/image/thankyou-img.webp' alt='thank you' />
              <p>Amidst nature’s calm beauty and welcoming warmth, De Coração becomes more than a destination… it becomes a place where memories gently unfold and peaceful moments stay with you.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
